import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { ProductStatus } from 'interfaces';

export type Product = {
  product_id?: number; // 상품 idx
  product_category_id?: number; // 상품 카테고리 idx
  tap_category_id?: number; // 탭 카테고리 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  forwarding_location_id?: number; // 출고지 idx
  stock_id?: number; // 재고관리 idx
  product_name?: string; // 상품명
  product_content?: string; // 내용
  num?: number; // 수량
  price?: number; // 가격
  is_show?: string; // 노출여부
  is_inventory?: string; // 재고관리 여부
  application_status?: string; // 신청상태
  type?: string; // 타입
  product_detail?: { [key: string]: Record<string, any> }; // 세부 정보
  is_refund?: string; // 환불여부
  product_code?: string; // 상품코드
  is_store_pickup?: string; // 스토어 픽업 여부
  is_bundle_delivery?: string; // 묶음배송 여부
  forwarding_information?: string; // 출고안내사항
  forwarding_date?: number; // 출고일
  packaging_method?: string; // 포장방법
  is_restocking_notification?: string; // 재입고알람여부
  product_status?: (typeof ProductStatus)[keyof typeof ProductStatus]; // 상품상태
  apply_feedback?: string; // 신청 피드백
  interruption_reason?: string; // 판매중단 사유
  delete_reason?: string; // 삭제 사유
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
  commission_rate?: number; // 수수료
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Product
   * --
   */
  getProducts: async (params?: { [key: string]: string | number }) => {
    try {
      // console.log(params);
      const res = await $http.get(APIConstant.GETS_PRODUCT, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Product
   * --
   */
  getProduct: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PRODUCT, { product_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Product
   * --
   */
  createProduct: async (body: Product) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PRODUCT, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Product
   * --
   */
  updateProduct: async (body: Product) => {
    try {
      const { product_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PRODUCT, {
        product_id: product_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Product
   * --
   */
  deleteProduct: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_PRODUCT, {
        product_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Product
   * --
   */
  getProductList: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PRODUCT_LIST, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  upsertProduct: async (body: Product[]) => {
    try {
      const res = await $http.bulk(APIConstant.UPSERT_PRODUCT, body, 'PUT');

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
